import Resume from "../settings/resume.json";

// Split the name into an array of parts
const names = Resume.basics.name.split(" ");

// Extract FirstName (the first element) and LastName (the last element)
const FirstName = names[0];
const LastName = names[names.length - 1];

// Combine the rest of the names (if any) as a middle name part
const middleNames = names.slice(1, names.length - 1).join(" ");

export const Initials = `${FirstName.charAt(0).toUpperCase()}${LastName.charAt(0).toUpperCase()}`;

export { FirstName, LastName, middleNames };
